import { useState } from 'react';

import { BoosterType } from '@/shared/types/Billing';

import { useBoosters } from './useBoosters';

export const useBoosterSeatsCounter = (initialCount?: number) => {
  const { purchasedBoosters } = useBoosters();
  const defaultCount = initialCount ?? purchasedBoosters?.[BoosterType.TeamspaceSeat]?.quantity ?? 1;

  const [seatsCount, setSeatsCount] = useState(defaultCount);

  const increment = () => {
    setSeatsCount((prev) => prev + 1);
  };

  const decrement = () => {
    setSeatsCount((prev) => (prev > 1 ? prev - 1 : prev));
  };

  return {
    decrement,
    increment,
    seatsCount,
    setSeatsCount,
  };
};
